export default {
    // The deployed C# backend — auth is handled by the C# app's Azure AD session
    csharpBackendUrl: 'https://app-powerbiembed-api-dev-nzn.azurewebsites.net',
    clientId: '03e8231b-c148-4559-8ffa-f28f6142fd96',
    authority: 'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    LogLevel: 5,
};
